function cacheHas(a,c){return a.has(c)}module.exports=cacheHas;